import React from 'react';
import { DatePicker, TimePicker } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import styles from './DateTimePicker.module.scss';
import DateInput from 'common/date-input/DateInput';
import clsx from 'clsx';

dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;

const DateAndTimePicker = ({
  value,
  onChange,
  showTime,
  picker,
  format = 'YYYY-MM-DD HH:mm:ss',
  disabledDate,
  disabledDateTime,
  label,
  variant,
  rowContainerClassName,
  useFloatingLabel = true,
  showNow = false,
  allowClear = true,
  ...props
}) => {
  const datePickerProps = {
    value: value ? dayjs(value, format) : null,
    onChange: onChange,
    format: format,
    showTime: showTime ? { format: 'HH:mm:ss', ...showTime } : undefined,
    disabledDate,
    disabledTime: disabledDateTime,
    variant: variant,
    showNow: showNow,
    allowClear: allowClear,
    ...props,
  };

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      {label && <div className={useFloatingLabel ? styles.label : 'mb-2 body-12-medium'}>{label}</div>}
      {picker === 'range' ? (
        <RangePicker {...datePickerProps} />
      ) : picker === 'time' ? (
        <TimePicker {...datePickerProps} />
      ) : picker === 'date-of-birth' ? (
        <DateInput
          {...datePickerProps}
          className={clsx(styles.inputField, 'h5-regular', props?.className ?? '')}
          format={format}
        />
      ) : (
        <DatePicker {...datePickerProps} />
      )}
    </div>
  );
};

export default DateAndTimePicker;
